import { UserToken } from "../types/User";

export const getTokenPayload = (token: string): UserToken => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
};

export function getAccessToken(): string | null {
    return localStorage.getItem('accessToken');
}

export function getRefreshToken(): string | null {
    return localStorage.getItem('refreshToken');
}

export function setAccessToken(token: string) {
    localStorage.setItem('accessToken', token);
}

export function setRefreshToken(token: string) {
    localStorage.setItem('refreshToken', token);
}